import { FileRecordExportProvider } from "@/panes/file-record-detail/FileRecordExportContext";
import { HtmlInlineEditProvider } from "@/panes/file-record-detail/HtmlInlineEditContext";
import {
  FileRecordVersionHistoryDialog,
  FileRecordVersionRestoreDialog,
  FileRecordVersioningProvider,
} from "@/panes/file-record-detail/versioning/FileRecordVersioningContext";
import type { FileRecord } from "@cohesive/api-client";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type FileRecordVersionHistoryCallableProps = {
  record: FileRecord;
};

/**
 * Imperative, self-contained version history dialog. It hosts its own
 * versioning + export providers so it doesn't depend on the file-record pane
 * (or the Notion editor) being mounted around it.
 */
export const FileRecordVersionHistoryCallable = createCallable<
  FileRecordVersionHistoryCallableProps,
  void
>(({ call, record }) => {
  return (
    <FileRecordExportProvider>
      <HtmlInlineEditProvider>
        <FileRecordVersioningProvider
          record={record}
          initialHistoryOpen
          onHistoryClose={() => call.end()}
        >
          <FileRecordVersionHistoryDialog />
          <FileRecordVersionRestoreDialog />
        </FileRecordVersioningProvider>
      </HtmlInlineEditProvider>
    </FileRecordExportProvider>
  );
}, UNMOUNTING_DELAY_MS);

FileRecordVersionHistoryCallable.displayName =
  "FileRecordVersionHistoryCallable";
